import axios from 'axios';

class WPApiService {
  
  constructor() {
    this.baseCustomUrl = `${window.location.origin}/wp-json/clienthub/v1`;
    this.baseUrl = `${window.location.origin}/wp-json/wp/v2`;

    const wpApiSettings = window.wpApiSettings || {};

    this.axiosInstance = axios.create({
        headers: {
            'X-WP-Nonce': wpApiSettings.nonce,
        },
        withCredentials: true,
    });
  }
  
  getGamesWithCountries() {
    const apiEndpoint = `${this.baseCustomUrl}/all-games-with-countries`;
    
    return axios.get(apiEndpoint)
        .then(response => response.data)
        .catch(error => {
          console.error('Error fetching client status report:', error);
          throw error;
        });
  }

  getGamesWithDetails() {
    const apiEndpoint = `${this.baseCustomUrl}/games-details`;
    
    return axios.get(apiEndpoint)
        .then(response => response.data)
        .catch(error => {
          console.error('Error fetching client status report:', error);
          throw error;
        });
  }

  getTaxonomies() {
    const apiEndpoint = `${this.baseUrl}/certified_market_social?orderby=name&order=asc`;
    
    return axios.get(apiEndpoint)
        .then(response => response.data)
        .catch(error => {
          console.error('Error fetching client status report:', error);
          throw error;
        });
  }

  addOrRemoveTaxonomy(postType, postId, taxonomy, termId, status) {
    const url = `${this.baseCustomUrl}/${postType}/${postId}/${taxonomy}/${termId}`;

    return this.axiosInstance.put(url, { 'status': status })
        .then(response => response.data)
        .catch(error => {
            console.error('Error fetching feedback options:', error);
            throw error;
        });
  }

  exportCertifiedMarkets() {
    const url = `${this.baseCustomUrl}/download-certified-markets`;

    return this.axiosInstance({
          url: url,
          method: 'GET',
          responseType: 'blob',
      })
      .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const date = new Date();
          let day = date.getDate().toString().padStart(2, "0");
          let month = (date.getMonth() + 1).toString().padStart(2, "0");
          let year = date.getFullYear();
          const fileName = `Game_List_EGT_Digital_${day}${month}${year}.xlsx`;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName); 
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      })
      .catch(error => {
          console.error('Error downloading the file:', error);
          throw error;
      });
  }
}

export default WPApiService;


// WEBPACK FOOTER //
// ./scripts/services/wpApiService.js